<template>
    <div>
        <!--div class="tabs is-centered">
            <ul>
                <li
                    :class="{
                        'is-active has-text-weight-bold': activeTab == 'person',
                    }"
                    @click="activeTab = 'person'"
                >
                    <a
                        v-t="$t('Project.participants_person_title')"
                        class=""
                    ></a>
                </li>
                <li
                    v-if="$store.getters.isTeacher"
                    :class="{
                        'is-active has-text-weight-bold': activeTab == 'groups',
                    }"
                    @click="activeTab = 'groups'"
                >
                    <a v-t="$t('Project.participants_groups_title')"></a>
                </li>
            </ul>
        </div-->
        <p
            v-t="$t(`Project.participants_${activeTab}_description`)"
            class="has-text-centered pb-3"
        ></p>
        <hr class="mb-4" />
        <project-configuration-people
            v-if="activeTab == 'person'"
            :default-permission="project.defaultPermission"
            :shared-with.sync="project.sharedWith"
            @resendInvitation="resendInvitation"
        />
        <!--project-configuration-groups
            v-if="$store.getters.isTeacher && activeTab == 'groups'"
            :default-permission="project.defaultPermission"
            :classes.sync="project.invitedClasses"
        /-->
    </div>
</template>

<script>
import ProjectConfigurationPeople from '@/components/ProjectConfigurationPeople';
//import ProjectConfigurationGroups from '@/components/ProjectConfigurationGroups';
import { inviteToProject } from '@/services/API';

export default {
    components: {
        ProjectConfigurationPeople,
        // ProjectConfigurationGroups,
    },
    props: {
        project: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data() {
        return {
            activeTab: 'person',
        };
    },
    methods: {
        resendInvitation(member) {
            console.log('resendreuqest', member);
            inviteToProject(this.project._id, [member]);
        },
    },
};
</script>

<style></style>
